import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * リリースプラン作成インスタンス詳細のインデックス。
 *
 * _layout 化により本文は `_layout/detail` へ移設したため、ここではタブ無し
 * アクセスを「詳細」タブへリダイレクトする（IT デバイスラベル発行と同パターン）。
 */
export const Route = createFileRoute('/_stacktrace/planning-operations-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/')({
  beforeLoad: ({
    params
  }) => {
    throw redirect({
      to: '/planning-operations-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/detail',
      params
    });
  }
});